<template>
  <ResponsiveLayout :progress="progress">
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>
    <div
      class="kds-main-wrapper"
      data-qa="insurance-overview"
    >
      <p
        class="kds-typography-title-xlarge"
        data-qa="insurance-overview-header"
        v-html="header"
      />

      <div class="kds-main-wrapper">
        <div
          v-for="(step, index) in privateInsuranceSteps"
          :key="step.key"
          class="kds-content-block"
          :data-qa="'insurance-overview-step-' + step.key"
        >
          <div
            class="kds-typography-title-large"
            data-qa="header"
            v-html="index + 1 + '. ' + $t(step.header)"
          />
          <div
            class="kds-typography-paragraph-large"
            data-qa="description"
            v-html="stepDescription(step)"
          />
          <div data-qa="cta">
            <BaseButton
              :text="$t(step.cta)"
              :data-qa="'submit-' + step.key"
              @click="handleCTAButtonClick(step)"
            >
              <template #append>
                <ArrowRightIcon />
              </template>
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </ResponsiveLayout>
</template>

<script setup>
import { computed } from 'vue'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { useI18n } from 'petite-vue-i18n'
import privateInsuranceSteps from '@eu/app/config/private-insurance-steps.json'
import BaseButton from '@shared/components/BaseButton.vue'
import ArrowRightIcon from '@shared/assets/icon/ArrowRightIcon.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'

const { t } = useI18n()
const corporateStore = useCorporateStore()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.INSURANCE_OVERVIEW,
)
const { progress } = useOnboardingProgress()

const corporate = computed(() => corporateStore.corporate)

const appName = computed(() => t('eu__generic__app'))
const header = computed(() =>
  corporate.value.insuranceType === 'public'
    ? t('eu__insurance_overview__public__header', { app_name: appName.value })
    : t('eu__insurance_overview__private__header', { app_name: appName.value }),
)

// step.key values are data (private-insurance-steps.json, also the data-qa
// surface e2e selects on) — map them to the route's intent names explicitly
const STEP_INTENTS = {
  'clarify-costs': 'clarifyCosts',
  'request-bill': 'requestBill',
  'verify-code': 'verifyCode',
}

const handleCTAButtonClick = (step) => {
  navigateNext(STEP_INTENTS[step.key])
}

const stepDescription = (step) => {
  return t(step.description, { app_name: appName.value })
}
</script>
